// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const potteryRow = defineModel({
  id: "pottery-row",
  batchId: "future",
  name: "Pottery row",
  tags: ["scenery","pottery","row","low-poly","age-of-mcp","future"],
  summary: "A row of finished pots — vessels that store and carry many goods.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.42,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.66, 0.04, 0.2), color: "#9a7544", position: [0, 0.02, 0] },
      { geometry: new THREE.CylinderGeometry(0.0648, 0.0495, 0.1612, 9), color: "#b9794a", position: [-0.22, 0.1206, 0] },
      { geometry: new THREE.SphereGeometry(0.09, 9, 6), color: "#b9794a", position: [-0.22, 0.183, 0], scale: [1, 0.62, 1] },
      { geometry: new THREE.CylinderGeometry(0.045, 0.036, 0.0468, 9), color: "#b9794a", position: [-0.22, 0.2532, 0] },
      { geometry: new THREE.CylinderGeometry(0.0792, 0.0605, 0.2108, 9), color: "#a96c40", position: [-0.02, 0.1454, 0] },
      { geometry: new THREE.SphereGeometry(0.11, 9, 6), color: "#a96c40", position: [-0.02, 0.227, 0], scale: [1, 0.62, 1] },
      { geometry: new THREE.CylinderGeometry(0.055, 0.044, 0.0612, 9), color: "#a96c40", position: [-0.02, 0.3188, 0] },
      { geometry: new THREE.CylinderGeometry(0.054, 0.04125, 0.124, 9), color: "#c78a58", position: [0.18, 0.102, 0] },
      { geometry: new THREE.SphereGeometry(0.075, 9, 6), color: "#c78a58", position: [0.18, 0.15, 0], scale: [1, 0.62, 1] },
      { geometry: new THREE.CylinderGeometry(0.0375, 0.03, 0.036, 9), color: "#c78a58", position: [0.18, 0.204, 0] },
      { geometry: new THREE.CylinderGeometry(0.0432, 0.033, 0.0992, 9), color: "#b9794a", position: [0.3, 0.0896, 0] },
      { geometry: new THREE.SphereGeometry(0.06, 9, 6), color: "#b9794a", position: [0.3, 0.128, 0], scale: [1, 0.62, 1] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.024, 0.0288, 9), color: "#b9794a", position: [0.3, 0.1712, 0] },
    ],
  animations: [],
});
